//export const API_BASE_URL = 'https://api.delivery.i3xhosting.com/api';
//export const API_BASE_URL = 'http://localhost:8000/api'; 
export const API_BASE_URL = 'https://api.test.i3xhosting.com/api'; 

export const API_ENDPOINTS = {
    AUTH: {
        LOGIN: '/login',
        LOGOUT: '/logout',
    },
    COMPANY: {
        LIST: '/companies',
        GET: '/companies',
        CREATE: '/companies',
        UPDATE: '/companies',
        DELETE: '/companies',
        SELECT: '/select-company'
    },
    EMPLOYEE: {
        LIST: '/employees',
        GET: '/employees',
        CREATE: '/employees',
        UPDATE: '/employees',
        DELETE: '/employees'
    }
} as const;

export const getHeaders = (token?: string, companyId?: number) => {
    const headers: Record<string, string> = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    };

    // If token not provided, try to get from localStorage
    const authToken = token || localStorage.getItem('token');
    const company = companyId || localStorage.getItem('selectedCompany');

    if (authToken) {
        headers['Authorization'] = `Bearer ${authToken}`;
    }

    if (company) {
        headers['X-Company-ID'] = `${company}`;
    }

    return headers;
};
